import {FC, useState} from 'react'
import {HoverDescription, DescriptionContainer} from 'jbc-front/components/presenters/ui/HoverDescription'
import {Alert} from 'jbc-front/components/icons'
import styles from './MissingOfficeIcon.scss'

export const MissingOfficeIcon: FC = () => {
  const [isHover, setIsHover] = useState<boolean>(false)

  const handleEnter = () => {
    setIsHover(true)
  }

  const handleLeave = () => {
    setIsHover(false)
  }

  return (
    <DescriptionContainer onMouseEnter={handleEnter} onMouseLeave={handleLeave} className={styles.icon}>
      <Alert size={17} />
      <HoverDescription position="top" isHover={isHover} margin={30}>
        適用事務所を設定してください
      </HoverDescription>
    </DescriptionContainer>
  )
}
